import { Box, Stack } from '@mui/material';
import { FieldMediaUpload } from '../../../form';
import { SlideFormProps } from './types';
import SlidePreview from './SlidePreview';
import { iriToId } from '../../../util';

export default function ImageSlideForm({
  slide,
  onUpdateField,
}: SlideFormProps) {
  return (
    <Stack direction="row" gap={3}>
      <Box sx={{ flex: 1 }}>
        <Stack gap={1}>
          <FieldMediaUpload
            field={{
              name: 'image_id',
              label: 'Image',
              value: slide.templateData.image_id,
              handleValueChange: (value) =>
                onUpdateField('image_id', value ? iriToId(value) : null),
            }}
            required
            acceptedTypes={['IMAGE_TYPE']}
            existingImageId={slide.templateData.image_id}
            helperText="9:16 aspect ratio"
            aspectRatio="9/16"
          />
        </Stack>
      </Box>

      <SlidePreview image={slide.templateData.image_id} type="image" />
    </Stack>
  );
}
